/**
 * Playready Key Message.
 *
 * @group DRM
 *
 * @beta
 */
export const PLAYREADY_KEY_MESSAGE = 'PlayReadyKeyMessage';
//# sourceMappingURL=PLAYREADY_KEY_MESSAGE.js.map